import { Dispatch } from "redux";
import { createRequestActionTypes } from "../../../../../utils/request-actions-helpers/createRequestActionTypes";
import { ApiConfig } from "../../../../../config/ApiConfig";
import { AppStateWithData } from "../../../../AppStateWithData";
import { RequestThunkParameters, createRequestThunk } from "../../../../../utils/request-actions-helpers/createRequestThunk";
import { GetCommentsAdditionalData } from "./getCommentsForDocument";

type UpdateLastUserEnterChatBody = string

export const getUpdateLastUserEnterChatDiscussionsActionTypes = createRequestActionTypes('UPDATE_LAST_USER_ENTER_CHAT_DISCUSSIONS')

export const updateLastUserEnterChatDiscussions = (config: ApiConfig) => (docId: string) => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const thunkParams: RequestThunkParameters<boolean, UpdateLastUserEnterChatBody, GetCommentsAdditionalData> = {
        method: 'POST',
        requestActionTypes: getUpdateLastUserEnterChatDiscussionsActionTypes,
        url: `${config.API_URL}/chat/updateLastSeenDiscussion`,
        body: docId,
        actionAdditionalData: {
            docId
        },
    }

    return dispatch<any>(createRequestThunk(thunkParams))
}

